import type { ErrorKind } from '../error-kind'

/** A failed user dependency load, tagged with the kind of failure and carrying the original error. */
export class UserDependenciesError extends Error {
    public constructor(
        public readonly kind: ErrorKind,
        public readonly cause: unknown,
    ) {
        super(cause instanceof Error ? cause.message : 'Failed to load user dependencies')
        this.name = 'UserDependenciesError'
        Object.setPrototypeOf(this, new.target.prototype)
    }

    /** The wrapped HTTP response, so a reader of the status or body sees the cause, not the wrapper. */
    public get response(): unknown {
        return (this.cause as { response?: unknown } | undefined)?.response
    }
}

/** The load succeeded and the user has no domains. This is an access outcome, not a transport failure. */
export class NoDomainsError extends UserDependenciesError {
    public constructor() {
        super('forbidden', undefined)
        this.message = 'The user has no domains'
        this.name = 'NoDomainsError'
    }
}
